<div class="flex flex-col w-full bg-[var(--colorGrey)] mt-8 mb-2 rounded p-4 text-[var(--color-text-strong)]">
    <p class="font-bold">{{ title() }}</p>
    <div class="flex flex-row justify-start mt-4 mb-4">
        <p class="text-[rgb(var(--ui-5))] mr-8">
            {{ startDate() | date: 'dd.MM.yyyy' : undefined : 'en' }} -
            {{ endDate() | date: 'dd.MM.yyyy' : undefined : 'en' }}
        </p>
        <p class="text-[rgb(var(--ui-5))]">
            {{ 'seasons.season-details.setting-cards.timeframe-card.end-of-application-phase-label' | translate }}:
            {{ applicationDeadlineDate() | date: 'dd.MM.yyyy' : undefined : 'en' }}
        </p>
    </div>
    <app-season-timeline
        [startDate]="startDate()"
        [endDate]="endDate()"
        [applicationDeadlineDate]="applicationDeadlineDate()"
    ></app-season-timeline>
    <div class="flex flex-row w-1/3 justify-start items-center mt-8 text-sm">
        <p class="mr-4 flex items-center gap-2">
            <span class="inline-block w-2 h-2 rounded-full bg-[var(--color-text-strong)]"></span>
            {{ 'seasons.season-details.setting-cards.timeframe-card.season-period-label' | translate }}
        </p>
        <p class="flex items-center gap-2">
            <span class="inline-block w-2 h-2 rounded-full bg-[var(--logo-1)]"></span>
            {{ 'seasons.season-details.setting-cards.timeframe-card.application-deadline-label' | translate }}
        </p>
    </div>
</div>
